export default __webpack_public_path__ + "static/media/sorceress.7f1472c8.png";